import {
  MdxCallout,
  MdxTabs,
  MdxTab,
  MdxAccordion,
  MdxAccordionGroup,
  MdxCard,
  MdxCardGroup,
  MdxSteps,
  MdxStep,
  MdxMdxHeading,
  MdxMdxLink,
  MdxMdxImage,
  MdxMdxCodeBlock,
  MdxMdxInlineCode,
  MdxMdxTable,
  MdxMdxTableHead,
  MdxMdxTableRow,
  MdxMdxTableHeader,
  MdxMdxTableData,
} from '@squareup/dex-feature-mdx-adapters';
import type { ComponentType } from 'react';

type MdxComponentMap = Record<string, ComponentType<Record<string, unknown>>>;

function getMdxComponentMap(): MdxComponentMap {
  return {
    // Fern callout components → Aside adapters
    Info: MdxCallout.Info,
    Warning: MdxCallout.Warning,
    Tip: MdxCallout.Tip,
    Note: MdxCallout.Note,
    Success: MdxCallout.Success,

    // Fern layout components
    Tabs: MdxTabs,
    Tab: MdxTab,
    Accordion: MdxAccordion,
    AccordionGroup: MdxAccordionGroup,
    Card: MdxCard,
    CardGroup: MdxCardGroup,
    Steps: MdxSteps,
    Step: MdxStep,

    // HTML element overrides
    h1: MdxMdxHeading.H1,
    h2: MdxMdxHeading.H2,
    h3: MdxMdxHeading.H3,
    h4: MdxMdxHeading.H4,
    a: MdxMdxLink,
    img: MdxMdxImage,
    pre: MdxMdxCodeBlock,
    code: MdxMdxInlineCode,
    table: MdxMdxTable,
    thead: MdxMdxTableHead,
    tr: MdxMdxTableRow,
    th: MdxMdxTableHeader,
    td: MdxMdxTableData,
  } as unknown as MdxComponentMap;
}

export { getMdxComponentMap };
export type { MdxComponentMap };
